/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import pick from 'lodash/pick';
import { defaultCurrency, } from '@zapier/currency/esm/hooks/useCurrencies';
import { formatPrice, formatPriceToBeInCurrency, RoundingStrategy, } from '@zapier/currency/esm/utils/formatPriceToBeInCurrency';
const priceCss = css({
    alignItems: 'center',
    display: 'inline-flex',
});
function getFormattedPrice(price, meta) {
    const { isLocalized, currency, roundingStrategy } = meta;
    const formattingOptions = Object.assign(Object.assign({}, pick(meta, ['minDecimals', 'maxDecimals'])), { useRelativeRounding: false });
    /**
     * Zero-decimal currencies need their price rounded based on a given strategy
     * They also need to be treated as whole dollars and not cents (avoid division by 100)
     */
    if (currency.zeroDecimal) {
        formattingOptions.isPriceGivenAsCents = !isLocalized;
        formattingOptions.roundingStrategy = roundingStrategy !== null && roundingStrategy !== void 0 ? roundingStrategy : RoundingStrategy.default;
    }
    return isLocalized
        ? formatPrice(price, formattingOptions)
        : formatPriceToBeInCurrency(price, currency, false, formattingOptions);
}
/**
 * Displays a price in a user-friendly format
 */
export const Price = ({ children, currency = defaultCurrency, maxDecimals = 2, minDecimals = 0, symbolFontSize = 'inherit', isLocalized = false, roundingStrategy, }) => {
    const absPrice = Math.abs(children);
    const isNegative = children < 0;
    const price = getFormattedPrice(absPrice, {
        currency,
        isLocalized,
        maxDecimals,
        minDecimals,
        roundingStrategy,
    });
    return (jsx("span", { css: priceCss },
        isNegative && jsx("span", null, "-"),
        jsx("span", { style: {
                fontSize: symbolFontSize,
            } }, currency.symbol),
        jsx("span", null, `${price} ${(currency === null || currency === void 0 ? void 0 : currency.symbol) === '$' ? currency.name : ''}`.trim())));
};
